import { render, staticRenderFns } from "./ViewBackground.vue?vue&type=template&id=1277b0be&"
import script from "./ViewBackground.vue?vue&type=script&lang=js&"
export * from "./ViewBackground.vue?vue&type=script&lang=js&"
import style0 from "./ViewBackground.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports